module.exports = __webpack_public_path__ + "img/suzuki_thumbnail.ff80b625.png";